import copy from 'copy-to-clipboard'
import { ActionHandler, ActionKey, MenuItem } from '../../Types'
import { ReactComponent as LinkIcon } from 'assets/icons/link16.svg'
import { ReactComponent as ArrowOutIcon } from 'assets/icons/arrow-out__16.svg'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import useOpenWindowSafely from 'hooks/useOpenWindowSafely'

interface Labels {
  copyLink?: string
  newTab?: string
}

const createLinkable = (labels?: Labels) => ({
  newTab: {
    key: ActionKey.openLinkInNewTab,
    textValue: labels?.newTab || 'Open in new tab',
    Icon: ArrowOutIcon,
  } as const,
  copyLink: {
    key: ActionKey.copyLink,
    textValue: labels?.copyLink || 'Copy link',
    Icon: LinkIcon,
  } as const,
})

interface Linkable {
  linkable: { newTab: MenuItem; copyLink: MenuItem }
  handleLinkable: ActionHandler
}

export const useLinkable = (url: string, actionLabels?: Labels): Linkable => {
  const openWindowSafely = useOpenWindowSafely()

  const handleLinkable = (key: ActionKey) => {
    switch (key) {
      case ActionKey.copyLink: {
        const copied = copy(url)
        if (copied) showToastMessage('Link copied', 'success')
        else showToastMessage('Could not copy link to your clipboard.', 'error')
        return true
      }

      case ActionKey.openLinkInNewTab: {
        openWindowSafely(url)
        return true
      }

      default:
        return false
    }
  }

  return {
    linkable: createLinkable(actionLabels),
    handleLinkable,
  }
}
